// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__VVN5K","rotation":"SmallLoader_rotation__W2pgN"};